import React from 'react';
import {
  DeleteButtonWrapper,
  DonutContainer,
  EditButtonWrapper,
  StyleSummaryCardContainer,
  SummaryActionsContainer,
  SummaryCardSection,
  SummaryCardTitle,
  SummaryCardTitleDepartment,
  SummaryDataContainer,
  SummaryInfosContainer,
  SummaryInfosTextContainer,
  SummaryInfosTitle,
  SummaryInfosTitlesContainer,
} from './styled.summaryCard';
import Donut from 'lqa-ui/lib/Components/Donut';
import { Status } from '../Status';
import { ISummaryCard } from '../../../@types/summaryCard';
import { useTranslation } from 'react-i18next';
import { Delete } from '../../../common/icons/Delete';
import { DateFormatEnum } from '../../../../helpers/dates';
import { EditPencil } from '../../../common/icons/EditPencil';
import { Body5 } from './../../../common/typography';
import moment from 'moment';

export function SummaryCard ({
  percentage,
  statusItems,
  department,
  sections,
  auditor,
  dueDate,
  actions,
}: ISummaryCard) {
  const { t } = useTranslation();
  const getDonutColor = (percentege: number) => {
    if (percentage === 0) {
      return 'danger';
    }

    if (percentege >= 80) {
      return 'success';
    }

    if (percentege < 50) {
      return 'danger';
    }

    return 'warning';
  };

  const sectionsLabel = sections.filter((section) => section).join(', ');

  return (
    <StyleSummaryCardContainer>
      <SummaryCardTitle>
        <SummaryCardTitleDepartment>{`${department}: `}</SummaryCardTitleDepartment>
        <SummaryCardSection>{sectionsLabel}</SummaryCardSection>
      </SummaryCardTitle>
      <SummaryDataContainer>
        {/*TODO create a new component for the donut chart*/}
        <DonutContainer>
        <Donut
          size={90}
          percentage={percentage}
          intent={getDonutColor(percentage)}
          decimals={1}
          percentageSign={true}
        />
        </DonutContainer>
        <SummaryInfosContainer>
          <SummaryInfosTextContainer>
            <SummaryInfosTitlesContainer>
              <SummaryInfosTitle>
                {t('COMMON.MY_AUDIT.SUMMARY_CARD.ASSIGNED_TO')}
              </SummaryInfosTitle>
              <SummaryInfosTitle>
                {t('COMMON.MY_AUDIT.SUMMARY_CARD.DUE_DATE')}
              </SummaryInfosTitle>
            </SummaryInfosTitlesContainer>
            <SummaryInfosTitlesContainer>
              <Body5 color="dimGray">{auditor}</Body5>
              <Body5 color={actions ? 'dimGray' : 'eerieBlack'}>
                {(dueDate && moment(dueDate).format(DateFormatEnum.ddmmyy)) ||
                  ''}
              </Body5>
            </SummaryInfosTitlesContainer>
          </SummaryInfosTextContainer>
          {statusItems && <Status items={statusItems} />}
          {actions && (
            <SummaryActionsContainer>
              <EditButtonWrapper onClick={actions.edit}>
                <EditPencil />
              </EditButtonWrapper>
              <DeleteButtonWrapper onClick={actions.delete}>
                <Delete />
              </DeleteButtonWrapper>
            </SummaryActionsContainer>
          )}
        </SummaryInfosContainer>
      </SummaryDataContainer>
    </StyleSummaryCardContainer>
  );
}
